import React from "react";
import Form from "./CustomForm";
import {useAlertContext} from "../hooks/use-alert";
import useForm from "../hooks/use-form";
import UserValidator from "../validators/user-validator.ts";
import { Createuser,updateUser } from "../apis/org_apis";
import { useNavigate } from "react-router-dom";


const validator = new UserValidator();

const properties = {
  name: { value: "", type: "text", isTouched: false, hasError: false },
  lastName: { value: "", type: "text", isTouched: false, hasError: false },
  userName: {
    value: "",
    type: "text",
    isTouched: false,
    hasError: false,
   

  },
  password: {
    value: "",
    type: "password",
    isTouched: false,
    hasError: false,

  },
confirmPassword: {
    value: "",
    type: "password",
    isTouched: false,
    hasError: false,

  },
   phoneNumber: {
     value: "",
     type: "text",
     isPhone: true,
     isTouched: false,
     hasError: false,
   },
   cellNumber: {
     value: "",
     type: "text",
     isPhone: true,
     isTouched: false,
     hasError: false,
   },
   email: {
     value: "",
     type: "text",
     isTouched: false,
     hasError: false,
   },
  
  address: {
    value: "",
    type: "text",
    isTouched: false,
    hasError: false,
  },
  
};

export default function User({ props }) {
 
  const navigate = useNavigate();
  const alert = useAlertContext();
  
  const { inputs, errorMessages, isValid, hasError, submitValidationHandler } =
  useForm(validator, properties);

  const handleSubmit = async (event) => {
    event.preventDefault();
    submitValidationHandler(event);
    if (isValid && !hasError) {
      let data = {};

      for (const input in inputs) {
        data[input] = inputs[input].value;
      }
      data["firstName"]=inputs["name"].value
      
      var response;
      var message;

      if (!props.update) {
        response = await Createuser(data);
        message = "Organization created successfully!";
      } else {
        data["roles"]=[{
          id:"1"
        }];
        data["organization"]={
          id:1
        };

        response = await updateUser(data);
        message = "Organization updated successfully!";
      }
      console.log("submit:" + JSON.stringify(response));
      if (response.success) {
        // success alert
        alert.setSuccess((prev) => [...prev,{
          status: true,
          message: message,
          index:prev.length
        }]);
        if (isNaN(props.steps)) {
          return props.custom ? props.onSubmit(false, true) : navigate("..");
        }
        
        return props.handleNext({
          id: response.object.id,
          name: data.name,
        });
      } else {
        alert.setError((prev) => [...prev,{ status: true, messages: response.errors,index:prev.length }]);
        return props.custom ? props.onSubmit(false) : null;
      }
    }
    return props.custom ? props.onSubmit(false) : null;
  };

  return (
    <>
      <Form
        title={"User setup :"}
        inputs={inputs}
        errorMessages={errorMessages}
        isValid={isValid}
        custom={props.custom ?? false}
        hasError={hasError}
        activeStep={props.activeStep}
        steps={props.steps}
        onSubmit={handleSubmit}
        externalSubmit={props.externalSubmit ?? null}
        handleBack={props.handleBack }
      />
    </>
  );
}
